module.exports = __webpack_public_path__ + "img/information-icon-active.dbe41db8.svg";